/** Adjustable table columns: registries, column state, templates (see columns.ts). */
import { ACCOUNTS_TABLE } from "./accounts.ts";
import type { TableDef, TableId } from "./columns.ts";
import { FILLS_TABLE, ORDERS_TABLE } from "./orders.ts";
import { POSITIONS_TABLE } from "./positions.ts";
import { sanitizeTableTemplates, type TableTemplatesDoc } from "./templates.ts";

export * from "./columns.ts";
export * from "./templates.ts";
export * from "./excursion.ts";
export * from "./positions.ts";
export * from "./accounts.ts";
export * from "./riskPresentation.ts";
export * from "./brokerRisk.ts";
export * from "./firmRules.ts";
export * from "./firmFigures.ts";
export * from "./orders.ts";
export * from "./labels.ts";

/** Every table's registry, for validating synced templates. */
export const TABLE_DEFS: Readonly<Record<TableId, TableDef<never>>> = {
  positions: POSITIONS_TABLE,
  accounts: ACCOUNTS_TABLE,
  orders: ORDERS_TABLE,
  fills: FILLS_TABLE,
};

/** The `table_templates` settings value, validated against every registry. */
export function tableTemplatesOf(raw: unknown): TableTemplatesDoc {
  return sanitizeTableTemplates(raw, TABLE_DEFS);
}
